module.exports = __webpack_public_path__ + "img/alphabet02.c23b9724.png";